<div #container class="nc-lightning-canvas-container"></div>
<div class="nc-content-wrapper">
    <ng-content></ng-content>
</div>
